module.exports = __webpack_public_path__ + "static/media/04_BOJO_MEIA_TACA_ESTAMPADO_09.03dc4084.jpg";